import { ModuleNode } from "../types";
import { hideTeradata, hidePresto, hideDMF, hideDG } from '../../../service/config'

export const platformObservabilityModule: ModuleNode = {
    key: "platform-observability",
    title: "Platform Observability",
    submodules: [
        ...(hideTeradata ? [] :
            [
                {
            key: "teradata-jobs",
            title: "Teradata Jobs",
            route: "/dashboard/platformCostLanding",
            pages: [
                {
                    key: "platform-executive",
                    title: "Platform Executive",
                    route: "/dashboard/business",
                    items: [
                        { key: "pe-dashboard", label: "Platform Executive Dashboard", tags: ["jobs", "critical", "platform"] },
                    ],
                },
                {
                    key: "jobs",
                    title: "Jobs",
                    route: "/jobs",
                    items: [
                        { key: "jobs", label: "Jobs", tags: ["Job Name", "platform", "jobs", "critical"] },
                    ],
                },
                {
                    key: "job-executions",
                    title: "Job Executions",
                    route: "/jobExecutions",
                    items: [
                        { key: "job-exec", label: "Job Executions", tags: ["Scheduled job", "process", "run status", "critical"] },
                    ],
                },
                {
                    key: "job-schedules",
                    title: "Job Schedules",
                    route: "/jobSchedules",
                    items: [
                        { key: "job-schedule", label: "Job schedules", tags: ["Scheduled job", "process", "critical"] },
                    ],
                },
                {
                    key: "infrastructure",
                    title: "Infrastructure",
                    route: "/job/Infrastructure",
                    items: [
                        { key: "infra", label: "Infrastructure", tags: ["host", "memory", "disk", "usage", "traffic"] },
                    ],
                },
            ],
        }]),
        {
            key: "tableau",
            title: "Tableau",
            route: "/dashboard/platformCostLanding",
            pages: [
                {
                    key: "tableau-admin-dashboard",
                    title: "Tableau Admin Dashboard",
                    route: "/tableau/admin/dashboard",
                    items: [],
                },
            ],
        },
        {
            key: "data-growth",
            title: "Data Growth",
            route: "/dashboard/platformCostLanding",
            pages: [
                {
                    key: "dashboard",
                    title: "Dashboard",
                    route: "/dataGrowth/dashboard",
                    items: [
                        { key: "report", label: "DB.Space Growth Report", tags: ["db", "space", "report", "growth"] },
                    ],
                },
                {
                    key: "powerbi",
                    title: "Power BI",
                    route: "/dataGrowthDataGrowth/dashboard",
                    items: [],
                },
                {
                    key: "databricks",
                    title: "Databricks",
                    route: "/dataGrowthDatabricks/dashboard",
                    items: [],
                },
                ...(hidePresto ? [] : [
                    {
                        key: "presto",
                        title: "Presto",
                        route: "/dataGrowthPresto/dashboard",
                        items: [],
                    }
                ]),
                {
                    key: "tableau",
                    title: "Tableau",
                    route: "/dataGrowthTableau/dashboard",
                    items: [],
                },
                {
                    key: "azure-storage",
                    title: "Azure Storage",
                    route: "/dataGrowth/azureStorage",
                    items: [
                        { key: "total-storage", label: "Total Storage", tags: ["total", "storage"] },
                        { key: "storage-growth-trend", label: "Storage Growth Trend", tags: ["growth", "trend", "storage"] },
                        { key: "top-storage-accounts", label: "Top Storage Accounts", tags: ["top", "accounts", "storage"] },
                    ],
                },
            ].filter(page => !hideDG(page.key)),
        },
        {
            key: "data-bricks",
            title: "Databricks",
            route: "/dashboard/platformCostLanding",
            pages: [
                {
                    key: "workspace-overview",
                    title: "Workspace Overview",
                    route: "/databricksADB/workspace",
                    items: [
                        { key: "workspace", label: "Workspace Overview", tags: ["cost", "DBU", "work spaces", "compute cost", "compute count"] },
                        { key: "overall-cost-ytd", label: "Overall Cost (YTD)", tags: ["overall", "cost", "ytd"] },
                        { key: "total-dbus", label: "Total DBUs", tags: ["dbu", "total"] },
                        { key: "active-workspaces", label: "Active Work Spaces", tags: ["active", "workspace"] },
                        { key: "top-spending-workspace", label: "Top Spending Workspace", tags: ["workspace", "spending"] },
                        { key: "compute-cost-by-type", label: "Compute Cost By Type", tags: ["compute", "cost", "type"] },
                        { key: "compute-count-by-type", label: "Compute Count By Type", tags: ["compute", "count", "type"] },
                        { key: "top-10-compute-spend", label: "Top 10 Compute Spend by Workspace", tags: ["workspace", "top10", "spending"] },
                        { key: "top-10-runtime-workspace", label: "Top 10 Runtime Workspace", tags: ["workspace", "top10", "runtime"] },
                        { key: "cost-vs-workspace-runtime", label: "Cost Vs Workspace with Runtime", tags: ["workspace", "runtime", "cost"] },
                        { key: "dbu-vs-workspace-runtime", label: "DBU Vs Workspace with Runtime", tags: ["workspace", "runtime", "dbu"] },

                    ],
                },
                {
                    key: "job-analytics",
                    title: "Jobs Analytics",
                    route: "/databricksADB/jobsADB",
                    items: [
                        { key: "job-analysis", label: "Job Analysis", tags: ["success rate", "status overview", "most expensive jobs"] },
                        { key: "overall-success-rate", label: "Overall Success Rate", tags: ["overall", "success", "rate"] },
                        { key: "total-cost-of-failed-jobs", label: "Total Cost of Failed Jobs", tags: ["total", "cost", "failed", "jobs"] },
                        { key: "job-status-overview", label: "Job Status Overview", tags: ["job", "status", "overview"] },
                        { key: "top-10-failure-reasons", label: "Top 10 Failure Reasons", tags: ["top10", "failure", "reasons"] },
                        { key: "top-100-most-expensive-jobs-dbu-analysis", label: "Top 100 Most Expensive Jobs - DBU Analysis", tags: ["top100", "expensive", "jobs", "dbu", "analysis"] },

                    ],
                },
                {
                    key: "cluster-analytics",
                    title: "Cluster Analytics",
                    route: "/databricksADB/clusteranalytics",
                    items: [
                        { key: "cluster-analysis", label: "Cluster Analytics", tags: ["cluster", "cost spend", "compute"] },
                        { key: "total-count-cluster-by-category", label: "Total Count Cluster By Category", tags: ["total", "count", "cluster", "by", "category"] },
                        { key: "cost-spend-by-category", label: "Cost Spend By Category", tags: ["cost", "spend", "by", "category"] },
                        { key: "total-cost-by-clusters-without-auto-termination", label: "Total Cost by Clusters Without Auto-Termination", tags: ["total", "cost", "clusters", "without", "auto-termination"] },
                        { key: "clusters-count-without-auto-termination", label: "Clusters Count Without Auto-Termination", tags: ["clusters", "count", "without", "auto-termination"] },
                        { key: "new-cluster-provisioned-by-category", label: "New Cluster Provisioned By Category", tags: ["new", "cluster", "provisioned", "by", "category"] },
                        { key: "clusters-spin-ups-by-category", label: "Clusters Spin-Ups by Category", tags: ["clusters", "spin-ups", "by", "category"] },
                        { key: "top-10-cluster-cost-by-compute-job", label: "Top 10 Cluster Cost by Compute - Job", tags: ["top", "10", "cluster", "cost", "by", "compute", "job"] },
                        { key: "top-10-cluster-cost-by-compute-interactive", label: "Top 10 Cluster Cost by Compute - Interactive", tags: ["top", "10", "cluster", "cost", "by", "compute", "interactive"] },

                    ],
                },
                {
                    key: "DBSQL-performance-dashboard",
                    title: "DBSQL Performance Dashboard",
                    route: "/databricksADB/dbsqlperfomance",
                    items: [
                        { key: "Warehouse-count", label: "Total Warehouses count By Category", tags: ["count", "warehouses", "category"] },
                        { key: "cost-category", label: "Total Cost By Category", tags: ["cost", "category"] },
                        { key: "warehouse-category", label: "New Warehouse By Category", tags: ["warehouse", "category"] },
                        { key: "warehouse-trend", label: "Warehouse Cost Trend", tags: ["cost", "warehouse", "trend"] },
                        { key: "volume-trend", label: "Query Volume Trend", tags: ["query", "volume", "trend"] },
                        { key: "dbu-warehouse", label: "Top 10 DBU Usage SQL Warehouses", tags: ["DBU", "sql", "warehouse"] },
                        { key: "sql-warehouse", label: "Top 10 Cost SQL Warehouse", tags: ["cost", "sql", "warehouse"] },
                        { key: "top-10-long-running-queries", label: "Top 10 Long Running Queries", tags: ["top", "10", "long", "running", "queries"] },
                        { key: "top-10-user-groups-by-dbu-usage", label: "Top 10 User/Groups by DBU Usage", tags: ["top", "10", "user/groups", "by", "dbu", "usage"] },
                        { key: "top-10-user-groups-by-cost", label: "Top 10 User/Groups by Cost", tags: ["top", "10", "user/groups", "by", "cost"] },
                        { key: "top-10-usage-catalogs", label: "Top 10 Usage Catalogs", tags: ["top", "10", "usage", "catalogs"] },
                        { key: "failed-queries", label: "Failed Queries", tags: ["failed", "queries"] },
                        { key: "peak-concurrency", label: "Peak Concurrency", tags: ["peak", "concurrency"] },

                    ],
                },
                {
                    key: "databricks-cost-management",
                    title: "Cost Management & Financial Analysis",
                    route: "/databricksADB/costmanagement",
                    items: [],
                },
                {
                    key: "CustomAnalysis-Recommendations-dashboard",
                    title: "Custom Analysis & Recommendations",
                    route: "/databricksADB/customanalysis",
                    items: [],
                },
            ],
        },
        {
            key: "powerbi",
            title: "Power BI",
            route: "/dashboard/platformCostLanding",
            pages: [
                // {
                //     key: "capacity",
                //     title: "Capacity",
                //     route: "/powerBI/capacity/dashboard",
                //     items: [],
                // },
                // {
                //     key: "dataset",
                //     title: "Dataset",
                //     route: "/powerBI/dataset/dashboard",
                //     items: [],
                // },
                // {
                //     key: "usage-governance",
                //     title: "Usage & Governance",
                //     route: "/powerBI/usage/dashboard",
                //     items: [],
                // },
                // {
                //     key: "infrastructure",
                //     title: "Infrastructure",
                //     route: "/powerBI/infrastructure/dashboard",
                //     items: [],
                // },
                // {
                //     key: "capacity-observability",
                //     title: "Capacity Observability",
                //     route: "/powerBI/capacityObservability/dashboard",
                //     items: [
                //         { key: "capacities-healthy", label: "Capacities Healthy", tags: ["capacities", "healthy"] },
                //         { key: "capacities-throttled", label: "Capacities Throttled", tags: ["capacities", "throttled", ] },
                //         { key: "capacities-frozen", label: "Capacities Frozen", tags: ["capacities", "frozen", ] },
                //         { key: "capacities-at-risk-of-getting-throttled", label: "Capacities at risk of Getting Throttled", tags: ["capacities", "risk", "throttled", ] },
                //         { key: "capacities-out-of-frozen-(in-last-24-hours)", label: "Capacities out of Frozen (In Last 24 hours)", tags: ["capacities", "out", "frozen", "24h", ] },
                //         { key: "capacities-cu%-utilization-over-time", label: "Capacities CU% Utilization Over Time", tags: ["capacities", "utilization", "CU", "time"] },
                //         { key: "details-table", label: "Details", tags: ["details", "capacity", "capacity owner"] },
                //     ],
                // },
                // {
                //     key: "adoption-metrics",
                //     title: "Adoption Metrics",
                //     route: "/powerBI/adoptionMetrics/dashboard",
                //     items: [
                //         { key: "total-power-bi-users", label: "Total Power BI Users", tags: ["total", "powerbi", "users"] },
                //         { key: "total-power-bi-reports", label: "Total Power BI Reports", tags: ["powerbi", "reports"] },
                //         { key: "capacity-growth", label: "Capacity Growth", tags: ["growth", "capacity"] },
                //         { key: "gateway-growth", label: "Gateway Growth", tags: ["gateway", "growth"] },
                //         { key: "reports-growth", label: "Reports Growth", tags: ["reports", "growth"] },
                //         { key: "users-growth", label: "Users Growth", tags: ["users", "growth"] },
                //         { key: "details", label: "Details", tags: ["details"] },
                //     ],
                // },
                {
                    key: "powerBI-admin-dashboard",
                    title: "Power BI Admin Dashboard",
                    route: "/powerBI/userActivity/dashboard",
                    items: [
                        { key: "active-users", label: "Active Users", tags: ["active", "users"] },
                        { key: "inactive-users", label: "Inactive Users", tags: ["inactive", "users"] },
                        { key: "creators", label: "Creators", tags: ["Creators"] },
                        { key: "viewers", label: "Viewers", tags: ["viewers"] },
                        { key: "user-growth-sector", label: "User Growth by Sector", tags: ["user", "growth", "sector"] },
                        { key: "user-activity-trend", label: "User Activity Trend", tags: ["user", "activity", "trend"] },
                        { key: "user-activity-details", label: "User Activity Details", tags: ["user", "activity"] },
                    ],
                },
            ],
        },
        ...(hidePresto ? [] : [
            {
                key: "presto",
                title: "Presto",
                route: "/dashboard/platformCostLanding",
                pages: [
                    {
                        key: "query-performance-summary",
                        title: "Query Performance Summary",
                        route: "/presto/dashboard",
                        items: [
                            { key: "query-details", label: "Query Details", tags: ["query", "details", "performance"] },
                        ],
                    },
                ],
            }
        ]),
        ...(hideDMF ? [] : [
            {
                key: "data-management-framework",
                title: "Data Management Framework",
                route: "/dashboard/platformCostLanding",
                pages: [
                    {
                        key: "health-summary",
                        title: "Health Summary",
                        route: "/dataManagementFramework/healthSummary/dashboard",
                        items: [],
                    },
                    {
                        key: "catalogues-quality",
                        title: "Catalogues & Quality",
                        route: "/dataManagementFramework/Catalogues/dashboard",
                        items: [],
                    },
                ],
            }
        ]),
        {
            key: "enterprise-platform-modernization-dashboard",
            title: "Enterprise Platform Modernization Dashboard",
            route: "/dashboard/platformCostLanding",
            pages: [
                {
                    key: "platform",
                    title: "Platform",
                    route: "/enterprisePlatform/dashboard",
                    items: [],
                },
            ],
        },
    ],
};
